import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=0b9128bf&scoped=true&"
import script from "./Warning.vue?vue&type=script&lang=js&"
export * from "./Warning.vue?vue&type=script&lang=js&"
import style0 from "./Warning.vue?vue&type=style&index=0&id=0b9128bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9128bf",
  null
  
)

export default component.exports